var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoValorTotal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "21px",
    viewBox: "0 0 28 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Valor Total") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS",
    transform: "translate(-50.000000, -973.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Valor-Total",
    transform: "translate(51.000000, 974.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.835443,12.8616405 C12.835443,13.9220456 9.96227848,14.781362 6.41772152,14.781362 C2.87316456,14.781362 0,13.9220456 0,12.8616405",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.835443,9.50513924 C12.835443,10.5655443 9.96227848,11.4248608 6.41772152,11.4248608 C2.87316456,11.4248608 0,10.5655443 0,9.50513924",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.835443,6.14863797 C12.835443,7.20904304 9.96227848,8.06835949 6.41772152,8.06835949 C2.87316456,8.06835949 0,7.20904304 0,6.14863797 C0,5.08823291 2.87316456,4.22891646 6.41772152,4.22891646 C9.96227848,4.22891646 12.835443,5.08823291 12.835443,6.14863797 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41772152,8.06845823 C2.87316456,8.06845823 0,7.20881266 0,6.14873671 L0,16.2179772 C0,17.2783823 2.87316456,18.1380278 6.41772152,18.1380278 C9.96227848,18.1380278 12.835443,17.2783823 12.835443,16.2179772 L12.835443,6.14873671 C12.835443,7.20881266 9.96227848,8.06845823 6.41772152,8.06845823 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7359848,8.63282278 C25.7359848,9.69322785 22.8628203,10.5525443 19.3182633,10.5525443 C15.7737063,10.5525443 12.9005418,9.69322785 12.9005418,8.63282278",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7359848,5.27632152 C25.7359848,6.33672658 22.8628203,7.19604304 19.3182633,7.19604304 C15.7737063,7.19604304 12.9005418,6.33672658 12.9005418,5.27632152",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7359848,1.91982025 C25.7359848,2.98022532 22.8628203,3.83954177 19.3182633,3.83954177 C15.7737063,3.83954177 12.9005418,2.98022532 12.9005418,1.91982025 C12.9005418,0.85941519 15.7737063,9.87341773e-05 19.3182633,9.87341773e-05 C22.8628203,9.87341773e-05 25.7359848,0.85941519 25.7359848,1.91982025 Z",
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3182962,3.83964051 C15.7737392,3.83964051 12.9005747,2.97999494 12.9005747,1.91991899 L12.9005747,11.9891595 C12.9005747,13.0495646 15.7737392,13.9092101 19.3182962,13.9092101 C22.8628532,13.9092101 25.7360177,13.0495646 25.7360177,11.9891595 L25.7360177,1.91991899 C25.7360177,2.97999494 22.8628532,3.83964051 19.3182962,3.83964051 Z",
    id: "Stroke-15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoValorTotal);
export default __webpack_public_path__ + "static/media/PictoValorTotal.604a912fb2a2e897c70c6fe525898349.svg";
export { ForwardRef as ReactComponent };